import { useAppSelector } from "../utils/hooks";

function isGroupLike(chatType: string | undefined) {
  return chatType === "group" || chatType === "public_group";
}

/** Тип чата активного звонка: из sessionStorage (при старте/входящем) или из Redux. */
export function useIsGroupCall() {
  const chatType = useAppSelector((s) => s.CurrentConversation.chat_type);
  if (typeof window === "undefined") return false;
  const stored = sessionStorage.getItem("call_chat_type");
  if (isGroupLike(stored || undefined)) return true;
  if (stored === "private") return false;
  return isGroupLike(chatType);
}
